(function () {
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.variant-card-atc-form');
    if (!form) return;

    e.preventDefault(); // 🚫 stop cart page redirect

    const button = form.querySelector('.variant-card__add');
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) throw res;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(res => res.json())
      .then(cart => {
        // ✅ update cart count silently
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(err => {
        console.error('Silent add to cart failed', err);
      })
      .finally(() => {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      });
  });
})();
